// swiper Slider
const swiper = new Swiper('.mySwiper', {
  slidesPerView: 2.1,     // 2 full + 0.1 peek
  spaceBetween: 17,       // gap between slides
  loop: false,            // IMPORTANT: avoid cloned slides shifting peek to left
  centeredSlides: false,  // ensure active slide starts at left edge
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

// header Js
document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.header-hamburger');
    const html = document.documentElement;
    const headerNav = document.querySelector('.header-nav-area');

    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('is-active');      // Toggle class on hamburger
      html.classList.toggle('nav-open');            // Toggle class on <html>
      headerNav.classList.toggle('is-open');       // Toggle class on navigation menu
    });
  });

// tabbing JS
const tabButtons = document.querySelectorAll('.every-tab-btn');
  const tabContents = document.querySelectorAll('.every-right-tab-desc-area');

  tabButtons.forEach(button => {
  button.addEventListener('click', () => {
  const tabNumber = button.getAttribute('data-tab');

  // Remove active class from all buttons
  tabButtons.forEach(btn => btn.classList.remove('active'));

  // Add active class to the clicked button
  button.classList.add('active');

  // Hide all tab contents
  tabContents.forEach(content => {
      content.classList.remove('active');
  });

  // Show the selected tab content
  document.querySelector(`[data-tab-content="${tabNumber}"]`).classList.add('active');
  });
});



function alignSwiperToPrimaryContainer() {
  const primaryContainer = document.querySelector('.the-design-sec .primary-container');
  const swiperSection = document.querySelector('.custom-img-slider');

  if (!primaryContainer || !swiperSection) return; // Stop if elements not found

  // Get the distance from the left edge of the viewport
  const leftSpace = primaryContainer.getBoundingClientRect().left || 0;
  
  // Apply margin-left
  swiperSection.style.marginLeft = leftSpace + 'px';
}

// Run once the page is ready
document.addEventListener('DOMContentLoaded', alignSwiperToPrimaryContainer);

// Adjust margin on window resize
window.addEventListener('resize', alignSwiperToPrimaryContainer);



// video Control





// comparison slider
const imageComparisonSlider = document.querySelector('[data-component="image-comparison-slider"]')

function setSliderstate(e, element) {
  const sliderRange = element.querySelector('[data-image-comparison-range]');

  if (e.type === 'input') {
    sliderRange.classList.add('image-comparison__range--active');
    return;
  }

  sliderRange.classList.remove('image-comparison__range--active');
  element.removeEventListener('mousemove', moveSliderThumb);
}

function moveSliderThumb(e) {
  const sliderRange = document.querySelector('[data-image-comparison-range]');
  const thumb = document.querySelector('[data-image-comparison-thumb]');
  let position = e.layerY - 20;

  if (e.layerY <= sliderRange.offsetTop) {
    position = -20;
  }

  if (e.layerY >= sliderRange.offsetHeight) {
    position = sliderRange.offsetHeight - 20;
  }

  thumb.style.top = `${position}px`;
}

function moveSliderRange(e, element) {
  const value = e.target.value;
  const slider = element.querySelector('[data-image-comparison-slider]');
  const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');

  slider.style.left = `${value}%`;
  imageWrapperOverlay.style.width = `${value}%`;

  element.addEventListener('mousemove', moveSliderThumb);
  setSliderstate(e, element);
}

function init(element) {
  const sliderRange = element.querySelector('[data-image-comparison-range]');

  if ('ontouchstart' in window === false) {
    sliderRange.addEventListener('mouseup', e => setSliderstate(e, element));
    sliderRange.addEventListener('mousedown', moveSliderThumb);
  }

  sliderRange.addEventListener('input', e => moveSliderRange(e, element));
  sliderRange.addEventListener('change', e => moveSliderRange(e, element));
}

init(imageComparisonSlider);


// Set the default z-index when the page loads
const captionAfter = document.querySelector('.image-comparison__caption--after');
if (captionAfter) {
  captionAfter.style.zIndex = '333';
}

function checkSliderPosition() {
  const slider = document.querySelector('.image-comparison__slider');
  const captionAfter = document.querySelector('.image-comparison__caption--after');

  if (!slider || !captionAfter) return;

  const leftValue = parseFloat(slider.style.left);

  if (leftValue >= 82) {
    captionAfter.style.zIndex = '0';
  } else {
    captionAfter.style.zIndex = '333';
  }
}

// Run this periodically or attach it to slider events
setInterval(checkSliderPosition, 100);
